// Adapters over the connector field spec served by voice-agents
// (`GET /agent-connector-credentials/registry`, AVR-620).
//
// The spec itself lives in voice-agents `src/services/connector_registry.py` and
// is fetched at render time — do NOT reintroduce a local table of connectors and
// fields here. A bundled copy silently drifts from the backend (a new field
// simply never renders), which is exactly what the endpoint removed.
//
// Payload shape:
//   { connectors: [{ connector, auth_type, fields: [{ name, required, secret }] }] }

// -> { [connector]: { auth, fields } }, keeping the server's field order (it is
// the form's render order).
export const indexRegistry = (payload) =>
  (payload?.connectors || []).reduce((acc, spec) => {
    acc[spec.connector] = { auth: spec.auth_type, fields: spec.fields || [] }
    return acc
  }, {})

export const connectorNames = (registry) => Object.keys(registry || {})
